export const homePage = '/';
export const aboutPage = '/about';
export const faqPage = '/frequently-asked-questions';
export const privacyPolicyPage = '/privacy-policy';
export const termsOfUsePage = '/terms-of-use';
export const cookieUsePage = '/cookie-use';
